<p-drawer
  [visible]="open"
  (onHide)="onCancel()"
  position="right"
  styleClass="add-group"
>
  <ng-template pTemplate="header">
    <div class="ngkit-flex-container-column">
      <div class="add-group__subtitle">Create</div>
      <div class="add-group__title">Group</div>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="ngkit-form-field">
      <label
        for="groupName"
        class="add-group__label ngkit-form-field__label">Group name</label>
      <div class="ngkit-form-field__input">
        <input
          #newGroupInput
          id="groupName"
          class="ngkit-width-full"
          [class.ngkit-error]="hasError()"
          type="text"
          pInputText
          [attr.maxlength]="groupNameMaxLength"
          [value]="newGroupName()"
          (input)="onGroupNameInputChange(newGroupInput.value)"
          [attr.aria-invalid]="hasError() || null"
          [attr.aria-describedby]="hasError() ? 'add-group-error' : null"
        />
        @if (hasError()) {
          <small
            id="add-group-error"
            role="alert"
            class="ngkit-form-field__feedback-message"
          >{{ displayError() }}</small>
        }
      </div>
    </div>

    <div class="ngkit-flex-container-row ngkit-spacing-t-3 ngkit-gap--xxxxs">
      <p-button
        label="Save and close"
        styleClass="ngkit-button ngkit-button-lg"
        severity="primary"
        [disabled]="isSaveButtonDisabled()"
        (onClick)="onSave()"
      ></p-button>
      <p-button
        label="Cancel"
        styleClass="ngkit-button ngkit-button-lg"
        severity="primary"
        variant="outlined"
        (onClick)="onCancel()"
      ></p-button>
    </div>
  </ng-template>
</p-drawer>